<div class="bar">
  <div class="progress" [style.width.%]="percentage()" [class.transition-progress]="enableTransition"></div>
</div>

<section class="flex full-width mt-12">
  <p class="body bold">You're {{ vm.roundedPercentage }}% done</p>
</section>
